export const getParagraphCount = (text) => {
    if (text.trim().length === 0) {
        return 0;
    }
    return text.replace(/\n$/gm, '').split(/\n/).length;
};
